export const GenerateScontrinoUrl = (
  parameters,
  fatturato,
  cassaCoeff,
  ibridoCase
) => {
  let url = "/calcolatore/?";

  for (const item in parameters) {
    if (
      item !== "fatturato" &&
      item !== "aliquotaCassa" &&
      item !== "ibridoCase"
    ) {
      url = `${url}${item}=${parameters[item]}&`;
    }
  }

  url = `${url}fatturato=${fatturato}&`;

  if (parameters.cassa === "1") {
    url = `${url}aliquotaCassa=${cassaCoeff}&`;
  }

  url = `${url}ibridoCase=${ibridoCase}&`;
  // console.log(url);
  return url;
};
